<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="fmtx1"><i>For Mom and Dad, who gave me a love of books. For Sean, who is my best promoter, and especially for our Mark—may you have many wise mentors to help you along your journey.</i></div>
<div class="fmtx1"><i>Ellen</i></div>
<div class="fmtx1"><div> <br/></div><i>For my mother and father, and my husband, Copil.</i></div>
<div class="fmtx1"><i>Susan</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ensh_9781118046876_oeb_ded_r1.vue?086fbd07